export const getStage = (index: number) => {
  let textLabel = '';
  switch (index) {
    case 0:
      textLabel = '1st Coat';
      break;
    case 1:
      textLabel = '2nd Coat';
      break;
    case 2:
      textLabel = '3rd Coat';
      break;
    case 3:
      textLabel = '4th Coat';
      break;
    case 4:
      textLabel = '5th Coat';
      break;
  }
  return textLabel;
};
